@if (user) {
  <div class="position-relative ps-3">
    <div
      class="d-flex align-items-center"
      [style.height.px]="defaultRowHeight$ | async"
      (mouseenter)="timelineInteractionService.setHoveredRowIndex(index)"
    >
      <div class="w-100">
        <wilson-timeline-user-details
          [user]="user"
          [smallText]="
            !!(
              !isLoadingUserAssignmentKpi &&
              userAssignmentKpis &&
              userAssignmentKpis.length
            )
          "
        ></wilson-timeline-user-details>
        <wilson-optimizer-assignments-user-kpis
          [userKpis]="userAssignmentKpis"
          [isLoadingKpiValue]="isLoadingUserAssignmentKpi"
        ></wilson-optimizer-assignments-user-kpis>
      </div>
    </div>
  </div>
}
